const momentFormats = {
  dateTimeFormat: "ddd, MMM D YYYY, HH:mm",
  timeFormat: "HH:mm",
  ampmDateTimeFormat: "ddd, MMM D YYYY, h:mm a",
  ampmTimeFormat: "h:mm a",
};

export default momentFormats;
